import { Command, CommandHandler, HttpService, TaggedUrl, Tags } from '@skylab-shared/core';

export interface SuzUpdateCredentialsParams {
	data: {
		isDefault: boolean,
		login: string,
		password: string,
	},
	firstSave: boolean
}

export class SuzUpdateCredentialsCommand extends Command<SuzUpdateCredentialsParams, void> { }

export class SuzUpdateCredentialsCommandHandlerBase implements CommandHandler<SuzUpdateCredentialsCommand, SuzUpdateCredentialsParams, void> {
	private static Url = TaggedUrl.join('suz', [Tags.Api]);

	public constructor(
		private readonly http: HttpService
	) {}

	public async handleAsync(command: SuzUpdateCredentialsCommand): Promise<void> {
		const params = command.params;
		if (!params) {
			throw new Error('Parameters are required.');
		}
		const method = params.firstSave ? 'post' : 'put';
		await this.http[method](SuzUpdateCredentialsCommandHandlerBase.Url, {
			...params.data
		});
	}
}
